export default __webpack_public_path__ + "static/hr-f1fedc5924e705a57b8caf38fe2ee199.svg";